import type { FC } from "react";

import type { IImageLoader } from "@Components/ImageLoader";
import ImageLoader from "@Components/ImageLoader";

import type { IBenefitItem } from "./BenefitItem";
import BenefitItem from "./BenefitItem";
import type { ILoyaltyDownloadPanel } from "./LoyaltyDownloadPanel";
import LoyaltyDownloadPanel from "./LoyaltyDownloadPanel";

import * as css from "./LandingPageLoyaltyCardInformation.module.css";

export interface ILandingPageLoyaltyCardInformation {
    titleLandingPage: string;
    cardImage: IImageLoader;
    loyaltyDownloadPanel: ILoyaltyDownloadPanel;
    titleBenefitPanel: string;
    benefits: IBenefitItem[];
    onClick: () => void;
}

export const LandingPageLoyaltyCardInformation: FC<ILandingPageLoyaltyCardInformation> = (props) => (
    <div className={css.landingPageLoyaltyCardInformationComponent}>
        <div className={css.landingPageLoyaltyTitle}>
            <header>
                <h1>{props.titleLandingPage}</h1>
            </header>
        </div>
        <div className={css.landingPageLoyaltyCardHeader}>
            <div className={css.cardImage}>
                <ImageLoader {...props.cardImage} />
            </div>
            <div className={css.panelLoyaltyDownload}>
                <LoyaltyDownloadPanel {...props.loyaltyDownloadPanel} />
            </div>
        </div>
        {props.benefits && props.benefits.length > 0 && (
            <div className={css.benefitPanel}>
                <header>
                    <h2>{props.titleBenefitPanel}</h2>
                </header>
                <div className={css.benefitItems}>
                    {props.benefits.map((item) => (
                        <BenefitItem key={item.title} {...item} onClick={props.onClick} />
                    ))}
                </div>
            </div>
        )}
    </div>
);
